

export default function Page404() {
	return(
		<div className="vh-100 py-5 d-flex flex-column">
			<h1 style={{fontFamily: "Montserrat"}} className="text-center">Sorry the page you are looking for is currently unavailable</h1>
			<img src="https://seosherpa.com/wp-content/uploads/2020/12/404-error-page-header-transparent.png" style={{objectFit: "cover"}} className="fitHeight"/>
		</div>
	)
}